export default {
    protocol: 'https',
    appHost: 'app.jivosite.com',
    googleClientId: '768888376116-p97u80ol5bje4nlb862u0v6qfhhvnk16.apps.googleusercontent.com'
}



// WEBPACK FOOTER //
// ./src/config.js